import { useQuery, UseQueryResult } from 'react-query';
import { GlobalService } from '../types/GlobalService';

const get = async (apiUrl: string, dataSourceId: string): Promise<GlobalService[]> => {
  if (!apiUrl || !dataSourceId) {
    throw new Error('Required properties are not set');
  }

  const response: Response = await fetch(`${apiUrl}/data-sources/${dataSourceId}/global-services`, {
    method: 'GET',
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error('Failed to fetch global services for data source');
  }

  return (await response.json()) as GlobalService[];
};

interface UseFetchGlobalServicesForDataSourceProps {
  dataSourceId?: string;
}

export const useFetchGlobalServicesForDataSource = ({
  dataSourceId,
}: UseFetchGlobalServicesForDataSourceProps): UseQueryResult<GlobalService[]> => {
  const apiUrl = window.BENCH?.auApi?.FIND_GLOBAL_SERVICES_API_URL || '';

  return useQuery({
    queryKey: ['getGlobalServicesForDataSource', dataSourceId],
    enabled: !!dataSourceId,
    queryFn: () => {
      if (!dataSourceId) {
        throw new Error('dataSourceId is required');
      }
      return get(apiUrl, dataSourceId);
    },
  });
};
